import _find from 'lodash/find';

export default class EditGroupRegisterController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, moment,
    groups,
    studentId,
    groupsRegisterRecord,
    StudentService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.groups = groups;
    this.studentId = studentId;
    this.groupsRegisterRecord = groupsRegisterRecord;
    this.StudentService = StudentService;

    this.group = _find(this.groups, item => item.id === this.groupsRegisterRecord.groupId);
    this.date = this.moment(this.groupsRegisterRecord.additionDate).toDate();
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  edit(form) {
    if (form.$invalid) {
      return false;
    }

    this.groupsRegisterRecord.groupId = this.group.id;
    this.groupsRegisterRecord.group = this.group;
    this.groupsRegisterRecord.dateOfAddition = this.moment(this.date).format('YYYY-MM-DD');
    this.StudentService.editGroupsRegisterRecord(this.studentId, this.groupsRegisterRecord)
      .then(() => {
        this.$mdDialog.hide();
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Zmieniono grupę')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}
